var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"absolute inset-0 animate-pulse rounded-lg -mx-1 -my-0.5 bg-gray-50",class:_vm.isLoading ? 'block' : 'hidden'})
}
var staticRenderFns = []

export { render, staticRenderFns }